import { render } from "./color-swatch.vue?vue&type=template&id=459d8231"
import script from "./color-swatch.vue?vue&type=script&lang=js"
export * from "./color-swatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__